import { Pipe, PipeTransform } from '@angular/core';
import { ArticleDto, JournalBaseModel } from 'src/graphql/generated-types';

@Pipe({
    name: 'articleLabel',
    standalone: false
})
export class ArticleLabelPipe implements PipeTransform {

    transform(article: ArticleDto): string {
        return [article.Produit?.Famille?.Activite?.Libelle
            ,article.Produit?.Libelle
            ,article.Libelle].filter(e=>!!e).join(' - ');
    }
}
